module.exports = __webpack_public_path__ + "static/media/Tree.e3b8c8e0.png";